import type { NotificacaoResumo } from '@/api/usuariosApi'
import {
  formatNotificacaoRelativa,
  getNotificacaoMeta,
  isNotificacaoLida,
} from '@/utils/notificacaoDisplay'
import styles from './NotificationCard.module.css'

type Props = {
  notificacao: NotificacaoResumo
  compact?: boolean
  onClick?: () => void
}

export function NotificationCard({ notificacao, compact, onClick }: Props) {
  const meta = getNotificacaoMeta(notificacao.tipo)
  const lida = isNotificacaoLida(notificacao)
  const rel = formatNotificacaoRelativa(notificacao.criada_em)

  return (
    <button
      type="button"
      className={`${styles.card} ${compact ? styles.cardCompact : ''} ${!lida ? styles.cardUnread : ''}`}
      onClick={onClick}
    >
      <span
        className={`${styles.icon} ${compact ? styles.iconCompact : ''} ${styles[`icon--${meta.tone}`]}`}
        aria-hidden
      >
        {meta.icon}
      </span>
      <span className={styles.content}>
        <span className={styles.topRow}>
          <span className={`${styles.title} ${compact ? styles.titleCompact : ''}`}>
            {notificacao.titulo}
          </span>
          {!compact && <span className={styles.badge}>{meta.label}</span>}
        </span>
        <span className={`${styles.message} ${compact ? styles.messageCompact : ''}`}>
          {notificacao.mensagem}
        </span>
        <span className={styles.meta}>{rel}</span>
      </span>
      {!lida && <span className={styles.unreadDot} aria-label="Não lida" />}
    </button>
  )
}
